export function getLoginHashUrl(): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  return `${base}/#/login`;
}

export function isOnLoginRoute(): boolean {
  return window.location.hash.startsWith("#/login");
}

export function redirectToLoginHashRoute(): void {
  if (isOnLoginRoute()) {
    return;
  }

  window.location.assign(getLoginHashUrl());
}
